module.exports = __webpack_public_path__ + "img/ER.9a10037e.svg";